/** Copy for "All else" (My Signals minus the viewer's favorites), shared by the model hook and the chip components. */

/** Toast when the favorites can't be excluded (one filters on Open business hours). */
export const ALL_ELSE_UNEXCLUDABLE_TOAST =
  "Showing all of My Signals. A favorite filters on Open business hours, so it can't be excluded.";

/** The save-blocked tip while "All else" is on: the exclusion is URL-only state, never part of a saved view. */
export const EXCLUDE_FAVORITES_SAVE_BLOCKED = "Remove 'Excluding your favorites' to save a view";

export const EXCLUDE_FAVORITES_LABEL = 'Excluding your favorites';
